<script setup>
import { computed, defineProps } from 'vue';

const props = defineProps({
    min: { type: [String, Number], required: true },
    max: { type: [String, Number], required: true },
    lastPrice: { type: [String, Number], required: true },
    direction: { type: String, required: true }
});

const toNumber = (v) => {
    if (typeof v === 'string') return parseFloat(v.replace('.', '').replace(',', '.'));

    return Number(v);
};

const percentage = computed(() => {
    const minNum = toNumber(props.min);
    const maxNum = toNumber(props.max);
    const lastNum = toNumber(props.lastPrice);

    if (maxNum === minNum) return 0;

    const val = ((lastNum - minNum) / (maxNum - minNum)) * 100;

    // clampen, damit der Cursor nicht aus dem Container rutscht
    return Math.min(100, Math.max(0, parseFloat(val.toFixed(2))));
});
</script>

<template>
    <div class="flex items-stretch gap-0 h-14 mx-4 my-4">
        <!-- Top -->
        <div class="flex flex-col items-end justify-start relative">
            <div class="border-b-2 border-dotted border-black w-24"></div>
            <div class="mt-1 mr-6">
                <p class="text-xxs leading-none text-slate-500">{{ $t('plain_top') }}</p>
                <p class="text-sm font-semibold">{{ props.max }}</p>
            </div>
        </div>

        <!-- PriceTarget -->
        <div class="relative min-w-4">
            <div class="absolute inset-0 rounded-full bg-blue-light"></div>
            <!-- Price cursor -->
            <div v-if="percentage > 0 && percentage < 100" class="absolute left-1/2 -translate-x-1/2 w-4 h-1 rounded-full bg-slate-900" :style="{ bottom: `${percentage}%` }"></div>
        </div>

        <!-- Bottom -->
        <div class="flex flex-col items-end justify-end relative">
            <div class="mb-1 ml-6">
                <p class="text-sm font-semibold">{{ props.min }}</p>
                <p class="text-xxs leading-none text-slate-500">{{ $t('plain_bottom') }}</p>
            </div>
            <div class="border-b-2 border-dotted border-black w-24"></div>
        </div>
    </div>
</template>
